import BaseOption from "%/dynamic-component-editor/classes/base-option";
import HideWhenZero from "%/dynamic-component-editor/options/hide-when-zero";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HideCountAtZero extends HideWhenZero {
  static userInterfaceComponent = {
    label: "Hide When Zero",
    optionDataType: BaseOption.DataType.Boolean,
    component: inspectorTools.RADIO_BAR,
    descriptionMessage: "Show nothing until a reader likes, votes or shares, instead of a 0.",
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };
}
